import { render, staticRenderFns } from "./FilterBlockComponent.vue?vue&type=template&id=3f804dfc&scoped=true&"
import script from "./FilterBlockComponent.vue?vue&type=script&lang=ts&"
export * from "./FilterBlockComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f804dfc",
  null
  
)

export default component.exports